import React from 'react';
import {Field} from 'redux-form';
import {I18n} from 'react-redux-i18n';

import FormInput from '../../common/components/FormInput';

const PLUField = () => {
  return (
		<tr>
      <td className="category">
        <Field name="pluKey" 
               component={FormInput} 
               type="text" 
               className="form-control"
               placeholder={I18n.t('PLU')}
        />
      </td>
      <td className="info">
        <Field name="plu" 
               component={FormInput} 
               type="text" 
               className="form-control"
               placeholder={I18n.t('ENTER_PLU')}
        />
      </td>
    </tr>
	);
};

export default PLUField;


/** WEBPACK FOOTER **
 ** ./src/modules/labels/components/PLUField.js
 **/